// extracted by mini-css-extract-plugin
export default {"btnWrap":"redeemBtn_btnWrap__Cf5Sh","redeem":"redeemBtn_redeem__nlsI2","title":"redeemBtn_title__8Z6ij","codeInput":"redeemBtn_codeInput__Xj+v9","apply":"redeemBtn_apply__B3sgK"};